const isHlsVideo = (src: string) => src.indexOf(".m3u8") !== -1;
export default isHlsVideo;
